import { useContext } from 'react'
import { GrowthBookContext } from '@growthbook/growthbook-react'

export const parseForcedFeatureFlags = (raw?: string): Set<string> =>
    new Set(
        (raw ?? '')
            .split(',')
            .map((flag) => flag.trim())
            .filter(Boolean)
    )

// Recette locale : sans clé GrowthBook aucun flag n'est lisible, d'où ce forçage par variable d'environnement
const forcedFlags = parseForcedFeatureFlags(process.env.NEXT_PUBLIC_FORCED_FEATURE_FLAGS)

export function useFeatureFlag(featureId: string): boolean {
    // useGrowthBook() throws outside a provider; the raw context defaults to {} instead
    const { growthbook } = useContext(GrowthBookContext)

    if (forcedFlags.has(featureId)) {
        return true
    }

    if (!growthbook) {
        return false
    }

    return growthbook.isOn(featureId)
}
